import { checkMaintenanceStatus, fetchDeviceMaintenance } from "../maintenance";
import { isSoketiConnected } from "./soketi";
import { MAINTENANCE_INTERVAL_CONFIG } from "./constants";

let maintenanceIntervalId = null;
let maintenanceFetchIntervalId = null;
let isProcessing = false;
let isFetching = false;

export const initSoketiMaintenanceInterval = () => {
    if (maintenanceIntervalId) {
        return;
    }

    if (!isSoketiConnected()) {
        return;
    }

    // Start the minute-based status checking interval
    maintenanceIntervalId = setInterval(() => {
        checkMaintenanceBoundaries();
    }, MAINTENANCE_INTERVAL_CONFIG.CHECK_INTERVAL_MS);

    // Start the 24-hour maintenance fetching interval
    maintenanceFetchIntervalId = setInterval(() => {
        fetchMaintenanceData();
    }, MAINTENANCE_INTERVAL_CONFIG.FETCH_INTERVAL_MS);

    // Run initial check
    checkMaintenanceBoundaries();
};

export const stopSoketiMaintenanceInterval = () => {
    if (maintenanceIntervalId) {
        clearInterval(maintenanceIntervalId);
        maintenanceIntervalId = null;
        isProcessing = false;
    }

    if (maintenanceFetchIntervalId) {
        clearInterval(maintenanceFetchIntervalId);
        maintenanceFetchIntervalId = null;
        isFetching = false;
    }
};

export const isSoketiMaintenanceIntervalRunning = () => {
    return maintenanceIntervalId !== null;
};

export const isSoketiMaintenanceFetchIntervalRunning = () => {
    return maintenanceFetchIntervalId !== null;
};

const checkMaintenanceBoundaries = async () => {
    if (isProcessing) {
        return;
    }

    if (!isSoketiConnected()) {
        stopSoketiMaintenanceInterval();
        return;
    }

    isProcessing = true;

    try {
        await checkMaintenanceStatus();
    } catch (error) {
        console.error('SOKETI_MAINTENANCE_INTERVAL - Error checking maintenance boundaries:', error);
    } finally {
        isProcessing = false;
    }
};

const fetchMaintenanceData = async () => {
    if (isFetching) {
        return;
    }

    if (!isSoketiConnected()) {
        stopSoketiMaintenanceInterval();
        return;
    }

    isFetching = true;

    try {
        await fetchDeviceMaintenance();
    } catch (error) {
        console.error('SOKETI_MAINTENANCE_INTERVAL - Error fetching maintenance data:', error);
    } finally {
        isFetching = false;
    }
};

export default {
    initSoketiMaintenanceInterval,
    stopSoketiMaintenanceInterval,
    isSoketiMaintenanceIntervalRunning,
    isSoketiMaintenanceFetchIntervalRunning
};
